/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-07 13:08:17
 */
export default {
  namespaced: true,
  state: {
    breadcrubs: [
      {
        name: '主页',
        path: '/app',
        noredirect: true
      }
    ]
  },
  mutations: {
    addBreadcrub (state, item) {
      let flog = false
      state.breadcrubs.forEach(value => {
        if (value.name === item.name) {
          flog = true
        }
      })
      if (!flog) {
        state.breadcrubs.push(item)
      }
    },
    moveBreadcrub (state, item) {
      let spliceIndex = 0
      state.breadcrubs.forEach((value, key) => {
        if (value.name === item.name) {
          spliceIndex = key
        }
      })
      state.breadcrubs.splice(spliceIndex)
    }
  },
  actions: {
    dispatchAddBreadcrub ({ commit }, item) {
      commit('addBreadcrub', item)
    },
    dispatchMoveBreadcrub ({ commit }, item) {
      commit('moveBreadcrub', item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/breadcrub.js